import { Component, OnInit, AfterViewInit, ElementRef } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { DatePipe } from '@angular/common';
import { ApiService } from 'src/app/services/api.service';
import { StorageService } from 'src/app/services/storage.service';
import { ActivatedRoute, Router } from "@angular/router";
import Swiper, { SwiperOptions } from 'swiper';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup } from '@angular/forms';

import {map, startWith} from 'rxjs/operators';
import {AsyncPipe} from '@angular/common';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-doctors',
  templateUrl: './doctors.component.html',
  styleUrls: ['./doctors.component.scss']
})
export class DoctorsComponent {
  // Define FormGroup
  searchForm: FormGroup;
  searchParams: any = "";
  loading: boolean = true;
  doctors: any[] = [];
  branches: any;
  hospitals:any;
  specialities: any;
  selectedBranchId: any = "";
  selectedSpecialityId: any = "";
  doctorName: string = "";
  doctorParams: any;
  error: any;
  currentBranchId: string | number = "";
  currentSpecialityId: string | number = "";
  hospitalId: any = "";
  branchId: any = "";
  specialtyId: any = "";
  searchTerm: any = "";
  hospital: any;
  selectedDoctorId: string | null = '';
  selectedHospitalId:any = "";
  selectedHospitalName: any;
  isHospitalApp: any;
  allBranches: any;
  allSpecialities: any;
  errorMessage: string = "";

  filteredDoctors!: Observable<any[]>;
  selectedDocId : any;

  constructor(public datePipe: DatePipe, private apiService: ApiService,
    public authService: AuthService, private storage: StorageService, private router: Router, private spinner: NgxSpinnerService, private formBuilder: FormBuilder, private snackBar: MatSnackBar, private route: ActivatedRoute,) {
      // Initialize FormGroup in constructor
      this.searchForm = this.formBuilder.group({
        hospitals: [''],
        branches: [''],
        specialities: [''],
        doctorName: [''],
      });
 }

  // Api call for getting hospital according to selected hospital id
  getSelectedHospital(hospitalId: string) {
    this.apiService.getHospital(hospitalId).subscribe({
      next: (response: any) => {
         if (response.success === true) {
           this.selectedHospitalName = response.data.name;
           
         }
       },
       error: (err: any) => {
         // hiding spinner
         this.spinner.hide();
         this.snackBar.open(err.error.message, '', {
           duration: 2000,
           horizontalPosition: 'center',
           verticalPosition: 'top',
           panelClass: 'text-center'
         });
         this.error = err.error.message;
       },
       complete: () => {
         // hiding spinner
         this.spinner.hide();
       }
     });
  }
  

  // Fetch branches for the selected hospital
  getBranchesForHospital(hospitalId: string) {
    this.spinner.show();
    this.apiService.getHospitalBranches(hospitalId).subscribe({
    next: (response: any) => {
        if (response.success === true) {
          this.allBranches = response.data;
          this.branches = [...this.allBranches];
          this.loading = false;
        }
      },
      error: (err: any) => {
        // hiding spinner
        this.snackBar.open(err.error.message, '', {
          duration: 2000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: 'text-center'
        });
        this.error = err.error.message;
        this.allBranches = [];
        this.spinner.hide();
      },
      complete: () => {
        // hiding spinner
        this.spinner.hide();
      }
    });
  }

  // Api call for getting hospital all branches
  getAllBranches(){
    this.apiService.getBranches().subscribe({
      next: (response: any) => {
      if (response.success === true) {
        this.branches = response.data.data;
      } 
    },
    });
  }

  // Fetch departments for the selected hospital
  getDepartmentsForHospital(hospitalId: string) {
    this.spinner.show();
    this.apiService.getHospitalDepartments(hospitalId).subscribe({
    next: (response: any) => {
        if (response.success === true) {
          this.allSpecialities = response.data.data;
          this.specialities = [...this.allSpecialities];
          this.loading = false;
        }
      },
      error: (err: any) => {
        // hiding spinner
        this.snackBar.open(err.error.message, '', {
          duration: 2000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: 'text-center'
        });
        this.error = err.error.message;
        this.allBranches = [];
        this.spinner.hide();
      },
      complete: () => {
        // hiding spinner
        this.spinner.hide();
      }
    });
  }

 // Fetch departments for the selected branch
  getDepartmentsForBranch(branchId: string) {
    this.spinner.show();
    this.apiService.getBranchDepartments(branchId).subscribe({
    next: (response: any) => {
        if (response.success === true) {
          this.allSpecialities = response.data.data;
          this.specialities = [...this.allSpecialities];
          this.loading = false;
        }
      },
      error: (err: any) => {
        // hiding spinner
        this.snackBar.open(err.error.message, '', {
          duration: 2000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: 'text-center'
        });
        this.error = err.error.message;
        this.allBranches = [];
        this.spinner.hide();
      },
      complete: () => {
        // hiding spinner
        this.spinner.hide();
      }
    });
  }

  // Api call for getting all Hospital Departments
  getSpecialties(){
    this.apiService.getDepartments().subscribe((response: any) => {
      if (response.success === true) {
        let completeSpecialties = response.data.data;
        this.specialities = completeSpecialties;
      } 
    });
  }

  // Event for getting branch id
  onBranchSelectionChange(selectedBranchId: number | string) {
    // Assigning selectedBranchId to any variable
    this.selectedBranchId = selectedBranchId;
    this.doctorParams = {
      'hospitalId': this.hospitalId,
      'branchId': this.selectedBranchId
    };
    if(this.selectedBranchId) {
      this.getDepartmentsForBranch(this.selectedBranchId);
      this.getDoctorsList(this.doctorParams);
      // Recalculate the filtered doctors after the branch selection changes
  this.filteredDoctors = this.searchForm.controls['doctorName'].valueChanges.pipe(
    startWith(''),
    map(value => this._filterDoctors(value || ''))
  );
    } else {
      this.getSpecialties();
    }

    
  }

  // Event for getting speciality id
  onSpecialitySelectionChange(selectedSpecialityId: number | string) {
    // Assign selectedBranchId to variable
    this.selectedSpecialityId = selectedSpecialityId;
    this.doctorParams = {
      'hospitalId': this.hospitalId,
      'specialtyId': this.selectedSpecialityId,
      'branchId' : this.selectedBranchId
    };
    if(this.selectedSpecialityId) {
      this.getDoctorsList(this.doctorParams);
       // Recalculate the filtered doctors after the speciality selection changes
  this.filteredDoctors = this.searchForm.controls['doctorName'].valueChanges.pipe(
    startWith(''),
    map(value => this._filterDoctors(value || ''))
  );
    }

   
  }


  // Function to handle doctor selection from the dropdown
  onDoctorSelection(event: any) {
    const selectedDoctor = event.option.value; // Extract the selected doctor object
    this.selectedDocId = selectedDoctor.title;
    

    this.doctorParams = {
      'specialtyId': this.selectedSpecialityId,
      'branchId': this.selectedBranchId,
      'searchTerm': this.selectedDocId
    };

    this.getSearchDoctors(this.doctorParams);

     // Ensure the filteredDoctors observable is updated
  // this.filteredDoctors = this.searchForm.controls['doctorName'].valueChanges.pipe(
  //   startWith(''),
  //   map(value => this._filterDoctors(value || ''))
  // );
  }


  getSearchDoctors(parameter: any) {
    // showing spinner
    this.spinner.show();
    // Api call for getting doctors according to params
    this.apiService.getBranchDoctorsList(parameter).subscribe({
      next: (response: any) => {
        if (response.success === true) {
          this.doctors = response.data.data;
          // this.filteredDoctors = this.searchForm.controls['doctorName'].valueChanges.pipe(
          //   startWith(''),
          //   map(value => this._filterDoctors(value || ''))
          // ); // Update filteredDoctors observable
          // hiding spinner
          this.spinner.hide();
        }else {
          this.snackBar.open(response.message, '', {
            duration: 2000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'text-center'
          });
          // hiding spinner
          this.spinner.hide();
        }
      },
      error: (err: any) => {
        // hiding spinner
        this.snackBar.open(err.message, '', {
          duration: 2000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: 'text-center'
        });
        // hiding spinner
        this.spinner.hide();
      },
      complete: () => {
        // hiding spinner
        this.spinner.hide();
      }
    });
  }
  

  // Api for listing doctors according to search params
  search() {
    this.doctorParams = {
      'hospitalId': this.selectedHospitalId,
        'branchId': this.selectedBranchId,
        'specialtyId': this.selectedSpecialityId,
        'searchTerm': this.selectedDocId
    };
    if(this.selectedBranchId) {
      this.getDoctorsList(this.doctorParams)
    }else {
      this.snackBar.open('Please select a branch and continue.', '', {
        duration: 2000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: 'text-center'
      });
    }
  }

  // Function for getting doctors according to search params
  getDoctorsList(parameter: any) {
    // showing spinner
    this.spinner.show();
    // Api call for getting doctors according to params
    this.apiService.getBranchDoctorsList(parameter).subscribe({
      next: (response: any) => {
        if (response.success === true) {
          this.doctors = response.data.data;
          this.filteredDoctors = this.searchForm.controls['doctorName'].valueChanges.pipe(
            startWith(''),
            map(value => this._filterDoctors(value || ''))
          ); // Update filteredDoctors observable
          // hiding spinner
          this.spinner.hide();
        }else {
          this.snackBar.open(response.message, '', {
            duration: 2000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'text-center'
          });
          // hiding spinner
          this.spinner.hide();
        }
      },
      error: (err: any) => {
        // hiding spinner
        this.snackBar.open(err.message, '', {
          duration: 2000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: 'text-center'
        });
        // hiding spinner
        this.spinner.hide();
      },
      complete: () => {
        // hiding spinner
        this.spinner.hide();
      }
    });
  }

bookNow(country: any) {
  this.storage.set('country_price', country.price);
  this.storage.set('selected-doctor', JSON.stringify(country));
  this.router.navigate(['/booking', country.id]).then(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top
  });
}

  ngOnInit(): void {    
    this.isHospitalApp = environment.isHospitalApp; 
    this.route.params.subscribe(params => {
       this.hospitalId = params['hospitalId'] ? params['hospitalId'] : '';
       this.branchId = params['branchId'] ? params['branchId'] : '';
      this.specialtyId = params['specialtyId'] ? params['specialtyId'] : '';
      this.searchTerm = params['searchTerm'] ? params['searchTerm'] : '';
      this.searchParams = {
        'hospitalId': this.hospitalId,
        'branchId': this.branchId,
        'specialtyId': this.specialtyId,
        'searchTerm': this.searchTerm
      }
    });
    this.getSelectedHospital(this.hospitalId);
    if (this.hospitalId) {   
      this.getBranchesForHospital(this.hospitalId);
      this.getDepartmentsForHospital(this.hospitalId);
      this.getDoctorsList(this.searchParams);

       // Setup the filteredDoctors observable based on form control value changes
    this.filteredDoctors = this.searchForm.controls['doctorName'].valueChanges.pipe(
      startWith(''),
      map(value => this._filterDoctors(value || ''))
    );
    } else {      
      this.getAllBranches();
      this.getSpecialties();
    }
  }

  // Filter doctors based on the input name
  private _filterDoctors(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.doctors.filter(doctor => doctor.title.toLowerCase().includes(filterValue));
  }

  // Display the doctor name in the autocomplete field
  displayDoctorFn(doctor: any): string {
    return doctor && doctor.title ? doctor.title : '';
  }

}
